
export function LoginLeftChart() {
    return (
        <table class="m-0 p-0 table table-borderless align-middle text-center HouseChartHeight"   >
        <tbody>
          <tr class="HouseChartRowHeight">
            <td class="border border-2 border-white HouseChartColumnWidth" style={{"background-color":"#93E9BE"}}>Pisces<br/>(Jupiter)</td>
            <td class="border border-2 border-white HouseChartColumnWidth" style={{"background-color":"red"}}>Aries<br/>(Mars)</td>
            <td class="border border-2 border-white HouseChartColumnWidth" style={{"background-color":"green", color:"white"}}>Taurus<br/>(Venus)</td>
            <td class="border border-2 border-white HouseChartColumnWidth" style={{"background-color":"yellow"}}>Gemini<br/>(Mercury)</td>
          </tr>
          <tr class="HouseChartRowHeight">
            <td class="border border-2 border-white" style={{"background-color":"Blue", color:"white"}}>Aquarius<br/>(Saturn)</td>
            <td class="text-center" style={{"background-color":"lightgreen", color:"white"}} colSpan="2" rowSpan="2">&nbsp;</td>
            <td class="border border-2 border-white" style={{"background-color":"#C0C0C0"}}>Cancer<br/>(Moon)</td>
          </tr>
          <tr class="HouseChartRowHeight">
            <td class="border border-2 border-white" style={{"background-color":"Gray"}}>Capricorn<br/>(Saturn)</td>
            <td class="border border-2 border-white" style={{"background-color":"#FFD700"}}>Leo<br/>(Sun)</td>
          </tr>
          <tr class="HouseChartRowHeight">
            <td class="border border-2 border-white" style={{"background-color":"Purple", color:"white"}}>Sagittarius<br/>(Jupiter)</td>
            <td class="border border-2 border-white" style={{"background-color":"Black", color:"white"}}>Scorpio<br/>(Mars)</td>
            <td class="border border-2 border-white" style={{"background-color":"LightBlue"}}>Libra<br/>(Venus)</td>
            <td class="border border-2 border-white" style={{"background-color":"Brown", color:"white"}}>Virgo<br/>(Mercury)</td>
          </tr>
        </tbody>  
      </table>
);
}